module.exports = __webpack_public_path__ + "media/images/adoption/adoption64-3775469e0195830d2f716018b89a86f4.jpg";